import React, { FunctionComponent } from "react";

const SingleNeutralCircleIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/users/geomertic-close-up-single-user-neutral/single-neutral-circle
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18.913,20.876a9.746,9.746,0,0,0-13.826,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default SingleNeutralCircleIcon;
